import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowSettingsRoute extends BaseRoute {}
